import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Optional,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  ForumReactionUser,
  ForumThreadReactionDetails,
} from "src/app/shared/interfaces/forum";
import { SharedModule } from "src/app/shared/shared.module";

export type ForumThreadReactionUsersModalData = ForumThreadReactionDetails & {
  currentUserId?: string | null;
};

export interface ForumThreadReactionUsersModalResult {
  action: "delete";
}

@Component({
  selector: "forum-thread-reaction-users-modal",
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: "./forum-thread-reaction-users-modal.component.html",
  styleUrls: ["./forum-thread-reaction-users-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForumThreadReactionUsersModalComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<ForumThreadReactionUsersModalComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public readonly data: ForumThreadReactionUsersModalData,
  ) {}

  getUserNameParts(name: string): { firstName: string; lastName: string } {
    const [firstName = "", ...rest] = (name || "").trim().split(/\s+/);

    return {
      firstName,
      lastName: rest.join(" "),
    };
  }

  trackByUserId(_index: number, user: ForumReactionUser): string {
    return user.id;
  }

  deleteReaction(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.dialogRef.close(<ForumThreadReactionUsersModalResult>{
      action: "delete",
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
